export const PER_PAGE_OPERATIONS = 50;
export const ALL_WALLETS_PER_PAGE = 50;
export const WALLETS_PER_PAGE = 50;
